const currencyFormatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const InvestmentPurchaseGridHeader = [
    {
        field: 'id',
        headerName: '#',
        minWidth: 50,
        flex: 0.55,
        headerClassName: 'super-app-theme--header',
        groupable: false,
        aggregable: false,
    },
    {
        field: 'InvoiceNr',
        headerName: 'Numri i Fatures',
        minWidth: 90,
        flex: 1.1,
        editable: false,
        headerClassName: 'super-app-theme--header',
        groupable: false,
        aggregable: false,
    },
    {
        field: 'Date',
        headerName: 'Data',
        minWidth: 85,
        flex: 1.05,
        editable: false,
        headerClassName: 'super-app-theme--header',
        groupable: false,
        aggregable: false,
    },
    {
        field: 'AccountName',
        headerName: 'Furnitori',
        minWidth: 140,
        flex: 1.9,
        editable: false,
        headerClassName: 'super-app-theme--header',
        groupable: false,
        aggregable: false,
    },
    {
        field: 'AmountWithoutVAT', headerName: 'Vlera', type: 'string', minWidth: 95, flex: 1.2, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'VATTotal', headerName: 'TVSH', type: 'string', minWidth: 95, flex: 1.15, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'Total', headerName: 'Total', type: 'string', minWidth: 95, flex: 1.1, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]